var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkylineRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 662,
    height: 780,
    viewBox: "0 0 662 780",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.5 539.5H340.5V781.5H397.5V539.5Z",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396 541H349H342V547.303V780H349V547.303H396V541Z",
    fill: "#0485BA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 1.5,
    width: 48,
    height: 193,
    transform: "matrix(-1 0 0 1 195 587)",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.5 480.5H596.5V781.5H567.5V480.5Z",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.5,
    y: 480.5,
    width: 30,
    height: 301,
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M545 482H539V488V655H545V488H566V482H545Z",
    fill: "#0485BA"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 569,
    y: 482,
    width: 26,
    height: 6,
    fill: "#0485BA"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.566476
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M558.5 460.452V478.548V460.452Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M558.5 460.452V478.548V460.452Z",
    fill: "#C5DBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.8 460.452V478.548H561.2V460.452H555.8Z",
    fill: "white",
    mask: "url(#path-8-inside-1)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 590.5,
    y: 526.5,
    width: 27,
    height: 255,
    fill: "white",
    stroke: "#F6AA58",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M597 528H592V534V780H597V534H616V528H597Z",
    fill: "#F6AA58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 640.5,
    y: 526.5,
    width: 20,
    height: 255,
    fill: "white",
    stroke: "#F6AA58",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 617.5,
    y: 526.5,
    width: 23,
    height: 255,
    fill: "white",
    stroke: "#F6AA58",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 634.5,
    y: 511.5,
    width: 13,
    height: 15,
    fill: "white",
    stroke: "#F6AA58",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 603.5,
    y: 511.5,
    width: 31,
    height: 15,
    fill: "white",
    stroke: "#F6AA58",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.566476
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-16-inside-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.5 519.452V537.548V519.452Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M432.5 519.452V537.548V519.452Z",
    fill: "#C5DBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.2 519.452V537.548H429.8V519.452H435.2Z",
    fill: "white",
    mask: "url(#path-16-inside-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M306.5 549.5V538.5H280.5V549V549.803L279.832 550.248L268.5 557.803V571.242V781.5H345.5V572.5H320H318.5V571V556.893L307.286 550.819L306.5 550.393V549.5Z",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 1.5,
    width: 20,
    height: 193,
    transform: "matrix(-1 0 0 1 215 587)",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 1.5,
    width: 105,
    height: 132,
    transform: "matrix(-1 0 0 1 271 648)",
    fill: "white",
    stroke: "#F6AA58",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215 590H204H198V596V647.998H204V596H215V590Z",
    fill: "#0485BA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 1.5,
    width: 39,
    height: 132,
    transform: "matrix(-1 0 0 1 166 648)",
    fill: "white",
    stroke: "#F6AA58",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M166 651H130V657H166V651Z",
    fill: "#F6AA58"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169 713V657V651H175H271V657H175V713H169Z",
    fill: "#F6AA58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.064 233.548L481.319 137.5H466.272L464.527 233.548H483.064Z",
    fill: "white",
    stroke: "#2CA0AF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 1.5,
    width: 13.1936,
    height: 16.8096,
    transform: "matrix(-1 0 0 1 473.812 226.512)",
    fill: "white",
    stroke: "#2CA0AF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.599 244.822L485.89 228.012H475.613V244.822H483.599Z",
    fill: "white",
    stroke: "#2CA0AF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.921 252.071C454.921 259.142 455.501 263.77 456.474 266.764C457.43 269.705 458.701 270.891 460.031 271.414C461.498 271.99 463.365 271.907 465.856 271.567C466.349 271.5 466.864 271.423 467.398 271.343C469.435 271.038 471.743 270.693 474.113 270.693C476.484 270.693 478.792 271.038 480.828 271.343C481.362 271.423 481.878 271.5 482.37 271.567C484.862 271.907 486.728 271.99 488.196 271.414C489.526 270.891 490.796 269.705 491.753 266.764C492.726 263.77 493.305 259.142 493.305 252.071C493.305 249.348 491.491 246.746 487.999 244.745C484.527 242.755 479.624 241.519 474.113 241.519C468.602 241.519 463.699 242.755 460.228 244.745C456.736 246.746 454.921 249.348 454.921 252.071Z",
    fill: "white",
    stroke: "#2CA0AF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.925 267.482C445.925 271.297 448.698 275.059 453.855 277.953C458.964 280.82 466.123 282.64 474.113 282.64C482.103 282.64 489.263 280.82 494.372 277.953C499.529 275.059 502.302 271.297 502.302 267.482C502.302 263.666 499.529 259.905 494.372 257.011C489.263 254.144 482.103 252.324 474.113 252.324C466.123 252.324 458.964 254.144 453.855 257.011C448.698 259.905 445.925 263.666 445.925 267.482Z",
    fill: "white",
    stroke: "#2CA0AF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.327 274.585C442.327 281.263 443.257 285.346 444.73 287.813C446.128 290.154 448.104 291.183 450.764 291.518C453.539 291.868 456.917 291.442 460.948 290.874C461.168 290.843 461.389 290.812 461.613 290.78C465.405 290.244 469.655 289.644 474.113 289.644C478.572 289.644 482.822 290.244 486.614 290.78C486.838 290.812 487.059 290.843 487.279 290.874C491.31 291.442 494.688 291.868 497.463 291.518C500.123 291.183 502.099 290.154 503.497 287.813C504.97 285.346 505.9 281.263 505.9 274.585C505.9 270.891 502.85 267.139 496.983 264.22C491.208 261.347 483.124 259.527 474.113 259.527C465.103 259.527 457.019 261.347 451.244 264.22C445.377 267.139 442.327 270.891 442.327 274.585Z",
    fill: "white",
    stroke: "#2CA0AF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.462 781.483C434.692 779.444 436.303 775.886 438.137 769.629C441.945 756.639 446.791 731.751 451.068 684.019C455.346 636.267 459.058 537.858 461.7 451.436C463.022 408.214 464.076 367.974 464.8 338.54C465.162 323.823 465.441 311.807 465.63 303.47C465.725 299.302 465.797 296.053 465.845 293.846C465.861 293.087 465.875 292.451 465.886 291.943H474.613V781.483H433.462Z",
    fill: "white",
    stroke: "#2CA0AF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.764 781.483C514.535 779.444 512.924 775.886 511.089 769.629C507.281 756.639 502.435 731.751 498.159 684.019C493.881 636.269 489.944 537.863 487.077 451.44C485.643 408.218 484.476 367.979 483.668 338.544C483.263 323.827 482.949 311.811 482.735 303.474C482.629 299.306 482.547 296.057 482.492 293.851C482.473 293.089 482.458 292.451 482.445 291.943H474.613V781.483H515.764Z",
    fill: "white",
    stroke: "#2CA0AF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.327 288.192C442.327 291.918 445.384 295.695 451.247 298.63C457.022 301.519 465.104 303.35 474.113 303.35C483.123 303.35 491.205 301.519 496.98 298.63C502.843 295.695 505.9 291.918 505.9 288.192C505.9 284.466 502.843 280.689 496.98 277.754C491.205 274.865 483.123 273.034 474.113 273.034C465.104 273.034 457.022 274.865 451.247 277.754C445.384 280.689 442.327 284.466 442.327 288.192Z",
    fill: "white",
    stroke: "#2CA0AF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.327 294.495C442.327 298.221 445.384 301.998 451.247 304.933C457.022 307.822 465.104 309.653 474.113 309.653C483.123 309.653 491.205 307.822 496.98 304.933C502.843 301.998 505.9 298.221 505.9 294.495C505.9 290.769 502.843 286.992 496.98 284.057C491.205 281.168 483.123 279.337 474.113 279.337C465.104 279.337 457.022 281.168 451.247 284.057C445.384 286.992 442.327 290.769 442.327 294.495Z",
    fill: "white",
    stroke: "#2CA0AF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.462 125.767L476.577 71.5H470.423L467.567 125.767C467.995 125.844 468.505 125.931 469.053 126.019C470.622 126.269 472.393 126.5 473.515 126.5C474.636 126.5 476.407 126.269 477.976 126.019C478.524 125.931 479.033 125.844 479.462 125.767Z",
    fill: "white",
    stroke: "#2CA0AF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.424 71.1876L476.362 45.5H470.638L469.576 71.1876C469.569 71.358 469.705 71.5 469.876 71.5H477.124C477.294 71.5 477.431 71.358 477.424 71.1876Z",
    fill: "white",
    stroke: "#2CA0AF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.385 45.1816L474.698 1.5H472.301L469.615 45.1816C469.604 45.3542 469.741 45.5 469.914 45.5H477.086C477.259 45.5 477.396 45.3542 477.385 45.1816Z",
    fill: "white",
    stroke: "#2CA0AF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.5 132C460.5 128.942 460.898 127.278 461.411 126.392C461.648 125.982 461.902 125.753 462.161 125.608C462.431 125.456 462.788 125.351 463.285 125.315C464.35 125.237 465.687 125.481 467.506 125.814C469.242 126.132 471.297 126.5 473.5 126.5C475.703 126.5 477.758 126.132 479.494 125.814C481.313 125.481 482.65 125.237 483.715 125.315C484.212 125.351 484.569 125.456 484.839 125.608C485.098 125.753 485.352 125.982 485.589 126.392C486.102 127.278 486.5 128.942 486.5 132C486.5 133.319 485.484 134.919 483.085 136.277C480.747 137.602 477.385 138.5 473.5 138.5C469.615 138.5 466.253 137.602 463.915 136.277C461.516 134.919 460.5 133.319 460.5 132Z",
    fill: "white",
    stroke: "#2CA0AF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 1.5,
    width: 25,
    height: 242,
    transform: "matrix(-1 0 0 1 421 538)",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M421 541H405H399V547.303V649H405V547.303H421V541Z",
    fill: "#0485BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 734.5H115.5V781.5H188.5V714.5H144.5V733V734.5H143Z",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 1.5,
    width: 162,
    height: 67,
    transform: "matrix(-1 0 0 1 349 713)",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349 716H196H190V722V780H196V722H349V716Z",
    fill: "#0485BA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149 716H180H187V722V780H180V722H149V736V739H146H117V736H146V722V716H149Z",
    fill: "#0485BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.5 714.5V700.5H278.5V714.5H289.5Z",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.5 714.5V700.5H250.5V714.5H278.5Z",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 1.5,
    width: 92,
    height: 67,
    transform: "matrix(-1 0 0 1 114 713)",
    fill: "white",
    stroke: "#2CA0AF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114 716H31H25V722V780H31V722H114V716Z",
    fill: "#2CA0AF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 1.5,
    width: 22,
    height: 67,
    transform: "matrix(-1 0 0 1 22 713)",
    fill: "white",
    stroke: "#2CA0AF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.5 714.5V703.5H58.5V714.5H115.5Z",
    fill: "white",
    stroke: "#2CA0AF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5 714.5V703.5H34.5V714.5H58.5Z",
    fill: "white",
    stroke: "#2CA0AF",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.5 781.5V760.5H93.5V781.5H134.5Z",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5 781.5V760.5H58.5V781.5H93.5Z",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 1.5,
    width: 71,
    height: 131,
    transform: "matrix(-1 0 0 1 556 649)",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 1.5,
    width: 27,
    height: 131,
    transform: "matrix(-1 0 0 1 416 649)",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 1.5,
    width: 69,
    height: 131,
    transform: "matrix(-1 0 0 1 485 649)",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M305 540H282V544.502H305V540Z",
    fill: "#0485BA"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-58-inside-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282 555V550.5L270 557.78V558V562V648H274V559.667L282 555Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M282 555V550.5L270 557.78V558V562V648H274V559.667L282 555Z",
    fill: "#C5DBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282 550.5L280.444 547.935L285 545.171V550.5H282ZM282 555H285V556.723L283.512 557.591L282 555ZM270 557.78H267V556.091L268.444 555.215L270 557.78ZM270 648V651H267V648H270ZM274 648H277V651H274V648ZM274 559.667H271V557.944L272.488 557.075L274 559.667ZM285 550.5V555H279V550.5H285ZM268.444 555.215L280.444 547.935L283.556 553.065L271.556 560.345L268.444 555.215ZM267 558V557.78H273V558H267ZM273 558V562H267V558H273ZM273 562V648H267V562H273ZM270 645H274V651H270V645ZM271 648V559.667H277V648H271ZM283.512 557.591L275.512 562.258L272.488 557.075L280.488 552.409L283.512 557.591Z",
    fill: "#0485BA",
    mask: "url(#path-58-inside-3)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 1.5,
    width: 29,
    height: 15,
    transform: "matrix(-1 0 0 1 450 634)",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 1.5,
    width: 90,
    height: 15,
    transform: "matrix(-1 0 0 1 540 634)",
    fill: "white",
    stroke: "#0485BA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M494 652H488V655V780H494V655H556V652H494Z",
    fill: "#0485BA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392 652H398H458H485V663H458H398V780H392V663V652Z",
    fill: "#0485BA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195 590H155H150V594.502V648H155V594.502H195V590Z",
    fill: "#0485BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 662,
    height: 780,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkylineRight);
export default __webpack_public_path__ + "static/media/skyline-right.a11b54cd81fb3ef54125ca1bdcb6f20e.svg";
export { ForwardRef as ReactComponent };